import { Pipe, PipeTransform } from '@angular/core';
import { StatesPluginService } from './states-plugin.service';

@Pipe({
    name: 'actionspipe',
    standalone: false
})
export class ActionsPipe implements PipeTransform {
  public actions: any;

  constructor(private service: StatesPluginService) {
    this.actions = this.service.getActions();
  }

  transform(id: string): any {
    return this.service.getValue(id, this.actions);
  }
}
